"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showScheme = void 0;
const type_1 = require("./type");
function showScheme(scheme, showQuantifiers = false) {
    const typeString = type_1.showType(scheme.type);
    const prefix = `∀${[...scheme.bound].join(',')}: `;
    return scheme.bound.size && showQuantifiers ? `${prefix}${typeString}` : typeString;
}
exports.showScheme = showScheme;
//# sourceMappingURL=scheme.js.map